import { useContext, useEffect, useState, useRef } from "react";
import { AuthContext } from "../../AuthContext";

const CurrentTrack = () => {
    const { accessToken } = useContext(AuthContext);
    const [currentTrack, setCurrentTrack] = useState(null);
    const [lastPlayedTrack, setLastPlayedTrack] = useState(null);
    const [isTitleOverflowing, setIsTitleOverflowing] = useState(false);
    const [isArtistOverflowing, setIsArtistOverflowing] = useState(false);
    const titleRef = useRef(null);
    const artistRef = useRef(null);

    const fetchCurrentTrack = async () => {
        try {
            const response = await fetch("https://api.spotify.com/v1/me/player/currently-playing", {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            const data = await response.json();
            if (data && data.item) {
                setCurrentTrack(data.item);
            } else {
                setCurrentTrack(null);
            }
        } catch (error) {
            console.error("Error fetching current track:", error);
        }
    };

    const fetchLastPlayedTrack = async () => {
        try {
            const response = await fetch("https://api.spotify.com/v1/me/player/recently-played?limit=1", {
                headers: { Authorization: `Bearer ${accessToken}` },
            });
            const data = await response.json();
            if (data && data.items.length > 0) {
                setLastPlayedTrack(data.items[0].track);
            }
        } catch (error) {
            console.error("Error fetching last played track:", error);
        }
    };

    useEffect(() => {
        if (!accessToken) return;

        fetchCurrentTrack();
        fetchLastPlayedTrack();

        const interval = setInterval(fetchCurrentTrack, 5000);
        return () => clearInterval(interval);
    }, [accessToken]);

    useEffect(() => {
        if (titleRef.current) {
            setIsTitleOverflowing(titleRef.current.scrollWidth > titleRef.current.clientWidth);
        }
        if (artistRef.current) {
            setIsArtistOverflowing(artistRef.current.scrollWidth > artistRef.current.clientWidth);
        }
    }, [currentTrack, lastPlayedTrack]);

    const track = currentTrack || lastPlayedTrack;

    if (!track) return <p className="text-gray-500 text-center">Şu anda çalan veya çalınmış bir şarkı bulunamadı.</p>;

    return (
        <div className="p-4 bg-gray-900 overflow-hidden text-white rounded-xl flex items-center shadow-lg">
            <img src={track.album.images[0].url} alt={track.name} className="w-16 h-16 rounded-md shadow-md" />
            <div className="ml-4 -mt-4 relative w-full overflow-hidden">
                <h3
                    ref={titleRef}
                    className={`text-lg font-semibold whitespace-nowrap ${isTitleOverflowing ? "animate-marquee" : ""}`}
                >
                    {track.name}
                </h3>
                <h3
                    ref={artistRef}
                    className={`text-sm text-gray-400 whitespace-nowrap ${isArtistOverflowing ? "animate-marquee" : ""}`}
                >
                    {track.artists.map((artist) => artist.name).join(", ")}
                </h3>
                {currentTrack ? <EqualizerAnimation /> : <p className="text-gray-400 text-sm">Son çalınan şarkı</p>}
            </div>
        </div>
    );
};

const EqualizerAnimation = () => {
    return (
        <div className="flex relative h-4 space-x-1 mt-2">
            {[1, 2, 3, 4, 5].map((i) => (
                <div
                    key={i}
                    className="w-1 bg-green-500 rounded-full animate-equalizer"
                    style={{ animationDelay: `${i * 0.1}s` }}
                />
            ))}
            <p className="pl-10 -mt-2 text-green-500 absolute"> Şu anda çalınıyor.</p>
        </div>
    );
};

export default CurrentTrack;
